import type { Attribution, UtmParams } from '@rg/shared';

const KEY = 'rg:attribution';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

/**
 * Captures first-touch attribution (UTM params, referrer, landing page) for this
 * browser session. Only marketing parameters are kept — no personal data.
 */
export function captureAttribution(
  loc: Location = window.location,
  referrer = document.referrer,
): void {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const params = new URLSearchParams(loc.search);
    const utm: UtmParams = {};
    for (const k of UTM_KEYS) {
      const v = params.get(k);
      if (v) utm[k] = v.slice(0, 200);
    }
    const external =
      referrer && !referrer.startsWith(loc.origin) ? referrer.slice(0, 500) : undefined;
    const data: Attribution = { utm, referrer: external, landingPage: loc.pathname.slice(0, 500) };
    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    /* storage unavailable (private mode) — attribution is optional */
  }
}

export function getAttribution(): Attribution | undefined {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Attribution) : undefined;
  } catch {
    return undefined;
  }
}
